import { Clickable, Col, GameItem, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const Updates = ({ data }) => {
  const isMobile = useSelector((state) => state.appState.isMobile),
    { t } = useTranslation(),
    dispatch = useDispatch();

  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  if (!data?.length) return null;

  if (isMobile)
    return (
      <Col wid="100%" marg="24px 0 0">
        <Row pad="0 16px" between wid="calc(100% - 32px)" center marg="0 0 8px">
          <Text h2>{t('profile.recentUpdates')}</Text>

          <Clickable onClick={handleGetApp}>
            <Text b2 bold>
              {t('common.seeAll')}
            </Text>
          </Clickable>
        </Row>

        <Row
          noFlex
          start
          between={!isMobile && data.length >= 3}
          scrollX={isMobile}
          wid={isMobile && '100vw'}
          gap={!isMobile && '24px'}
        >
          {data.slice(0, 3).map((x, i) => (
            <Col noFlex key={i} marg={!i ? isMobile && '0 12px 0 16px' : isMobile && '0 16px 0 0'}>
              <GameItem item={x} />
            </Col>
          ))}
        </Row>
      </Col>
    );

  return (
    <Col>
      <Text h2 marg="0 0 16px">
        {t('profile.recentUpdates')}
      </Text>

      <Row gap={!isMobile && '24px'} wrapFlex start>
        {data.slice(0, 10).map((x, i) => (
          <Col noFlex key={i} marg={!i ? isMobile && '0 12px 0 16px' : isMobile && '0 16px 0 0'}>
            <GameItem item={x} />
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default Updates;
